import { render } from "./dashboard.vue?vue&type=template&id=7016169a&scoped=true"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7016169a"

export default script